import { type ReactElement, useId } from "react";
import { AsyncComponent } from "./AsyncComponent";
import { ComponentContentProps } from "../../../data/transformer/componentTransformer.ts";

export type ComponentRendererProps = {
  content: Array<ComponentContentProps>;
};

export function ComponentRenderer({
  content,
}: ComponentRendererProps): ReactElement | null {
  const id = useId();

  if (!content || content.length === 0) {
    return null;
  }

  return (
    <>
      <>
        {content.map((item) => (
          <AsyncComponent key={`${id}:${item.id ?? Date.now()}`} item={item} />
        ))}
      </>
    </>
  );
}
